import { Helmet } from "react-helmet-async";
import { CourseCategories } from "../components/home/CourseCategories";
import { Reveal } from "../components/Reveal";

export default function CoursesPage() {
  return (
    <>
      <Helmet>
        <title>All Courses | LearnWithTAC — Network, Cloud & Cyber Security</title>
        <meta
          name="description"
          content="Browse all 33 one-to-one live courses: CCNA, CCNP, Palo Alto, FortiGate, F5, SD-WAN, Azure, AWS, CEH, OSCP, CISSP, AI & GenAI and more — with 24x7 labs and mock interviews."
        />
      </Helmet>
      <section className="relative py-16 sm:py-20 overflow-hidden">
        <div className="absolute inset-0 grid-bg" />
        <div className="absolute -top-24 left-1/3 w-[420px] h-[420px] rounded-full bg-blue-700/20 blur-[130px]" />
        <Reveal className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="font-mono2 text-xs uppercase tracking-[0.25em] text-orange-500 font-semibold mb-4">
            Full Course Catalog
          </p>
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
            Every Course. <span className="text-gradient-sky">One-on-One.</span>{" "}
            <span className="text-gradient-orange">Job-Focused.</span>
          </h1>
          <p className="mt-4 max-w-2xl mx-auto text-base sm:text-lg text-slate-400">
            Click any course for full syllabus, prerequisites, career outcomes and your trainer's profile.
          </p>
        </Reveal>
      </section>
      <CourseCategories showAll />
    </>
  );
}
